import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {
    ReferenceBookResponse,
    ReferenceBookType,
    TrendIncidentResponse,
} from '@npck/af-frontend-api';
import {DATE_TIME_UI_FORMAT, Spinner} from '@npck/libs/commons';
import dayjs from 'dayjs';
import {BehaviorSubject, combineLatest} from 'rxjs';
import {DictionaryHolderService, findValueInDictionary} from '../../../../../../domain/dictionary-holder.service';

@Component({
    selector: 'af-trend-incident',
    templateUrl: './trend-incident.component.html',
    styleUrl: './trend-incident.component.scss',
    standalone: false,
})
export class TrendIncidentComponent implements OnInit {
    @Input() form: FormGroup<TrendIncidentForm>;
    @Input() trendIncident: TrendIncidentResponse;
    @Input() formInitialized: BehaviorSubject<boolean>;
    Spinner = Spinner;

    constructor(
        private cdr: ChangeDetectorRef,
        private dictionaryHolderService: DictionaryHolderService
    ) {
    }

    ngOnInit(): void {
        combineLatest([
            this.dictionaryHolderService.getReference(ReferenceBookType.INCIDENT_STATUS),
            this.dictionaryHolderService.getReference(ReferenceBookType.BIN),
        ]).subscribe(([incidentStatuses, bins]) => {
            this.buildForm(incidentStatuses, bins);
        });
    }

    private buildForm(statuses: ReferenceBookResponse[], bins: ReferenceBookResponse[]): void {
        const relatedOrganizations = this.trendIncident?.relatedOrganizations?.map(orgBin =>
            findValueInDictionary(bins, orgBin, 'name_ru') ?? '-'
        ).join(', ');

        const governmentOrganization= findValueInDictionary(bins, this.trendIncident?.governmentBin, 'name_ru') ?? '';
        const createdByOrganization= findValueInDictionary(
            bins,
            this.trendIncident?.incidentCreatedByOrganization,
            'name_ru'
        ) ?? '';
        const status = findValueInDictionary(statuses, this.trendIncident?.incidentStatus, 'name_ru') ?? '';
        const resolutionStatus = findValueInDictionary(statuses, this.trendIncident?.incidentStatus, 'name_ru') ?? '';


        this.form.addControl('incidentId', new FormControl(this.trendIncident?.incidentId, [Validators.required]));
        this.form.addControl('relatedOrganizations', new FormControl(relatedOrganizations));
        this.form.addControl('governmentOrganization', new FormControl(governmentOrganization));
        this.form.addControl('createdByOrganization', new FormControl(createdByOrganization));
        this.form.addControl('status', new FormControl(status));
        this.form.addControl('resolution', new FormControl(resolutionStatus));
        this.form.addControl('createdDate', new FormControl(this.formatDate(this.trendIncident?.incidentCreatedDate)));
    }

    private formatDate(date: string): string {
        return date ? dayjs(date).format(DATE_TIME_UI_FORMAT) : '-';
    }
}

export interface TrendIncidentForm {
    incidentId?: FormControl<string>;
    relatedOrganizations?: FormControl<string>;
    governmentOrganization?: FormControl<string>;
    createdByOrganization?: FormControl<string>;
    status?: FormControl<string>;
    resolution?: FormControl<string>;
    createdDate?: FormControl<string>;
}
